import { useTranslation } from 'react-i18next'
import { authInputClass, authLabelClass } from '../auth/authTheme'
import {
  getStoredReferralCode,
  setStoredReferralCode,
} from '../../services/referral'

export { getStoredReferralCode, setStoredReferralCode }

interface ReferralCodeInputProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  variant?: 'dark' | 'light'
}

export default function ReferralCodeInput({
  value,
  onChange,
  disabled = false,
  variant = 'light',
}: ReferralCodeInputProps) {
  const { t } = useTranslation('auth')

  const handleChange = (next: string) => {
    const normalized = next.toUpperCase()
    onChange(normalized)
    setStoredReferralCode(normalized)
  }

  const inputClass =
    variant === 'dark'
      ? authInputClass
      : 'w-full rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF5A00]/30'

  const labelClass =
    variant === 'dark' ? authLabelClass : 'block text-sm font-medium text-gray-700 mb-1'

  return (
    <div>
      <label htmlFor="referral_code" className={labelClass}>
        {t('register.referralCodeLabel')}{' '}
        <span className="text-xs font-normal opacity-70">({t('register.referralCodeOptional')})</span>
      </label>
      <input
        id="referral_code"
        name="referral_code"
        type="text"
        autoComplete="off"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={t('register.referralCodePlaceholder')}
        maxLength={32}
        disabled={disabled}
        className={`mt-1 ${inputClass}`}
      />
    </div>
  )
}
